import React, { useState  , useEffect} from 'react';
import axios from 'axios';
// import './Search.css';
// import AccessoriesForm from './AccessoriesForm';
import LaptopAcceForm from './LaptopAcceForm';
import TwoWheelerForm from '../TwoWheeler/TwoWheelerForm';
import { useInput } from '../Context';
import EmployeeDetails from '../EmployeeDetails/EmployeeDetails';

export default function LaptopAcce() {

  const { inputValue, handleSearch, laptopacce } = useInput();
  const [searchTerm, setSearchTerm] = useState('');
  // const [searchResults, setSearchResults] = useState([]);
  const [isSearchBarActive, setIsSearchBarActive] = useState(true);
  const [editingData, setEditingData] = useState(null); // Track the row being edited
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formMode, setFormMode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);


  useEffect(() => {
    // Retrieve the stored value from sessionStorage
    const storedPreference = sessionStorage.getItem('user');
    setUser(storedPreference);
  }, []);


  const handleToggleForm = () => {
    setIsFormOpen((prev) => !prev); // Toggle the form state
  };

  // Handle search when the user types
  // const handleSearch = async (term) => {
  //   if (term) {
  //     try {
  //       const response = await axios.get(`https://api.assetview.warrantyindia.com/search?q=${term}`);
  //       setSearchResults(response.data);  // Update search results with the response data
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //       setSearchResults([]);  // Clear search results on error
  //     }
  //   } else {
  //     setSearchResults([]);
  //   }
  // };

  // Handle input change and automatically search
  const handleInputChange = (e) => {
    const term = e.target.value;
    handleSearch(term);  // Trigger search for both employees and two-wheelers
  };

  const handleViewClick = (data) => {
    setEditingData(data);  // Populate the form with the clicked row's data
    setFormMode('view');   // Set mode to 'view'
  };

  // Handle the "Edit" button click
  const handleEditClick = (data) => {
    setEditingData(data);  // Populate the form with the clicked row's data
    setFormMode('edit');   // Set mode to 'edit'
  };

  // Handle form input change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setEditingData({ ...editingData, [name]: value });
  };

  

  // Handle form submit to save the edited data
  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    // Simple validation for required fields
    if (!editingData.employee_name || !editingData.contact_no) {
      alert("Please fill in all required fields.");
      return;
    }
  
    try {
      setLoading(true); // Set loading state
  
      const response = await axios.put(`https://api.assetview.warrantyindia.com/api/updateaccessories1/${editingData.id}`, editingData);
  
      if (response.status === 200) {
        alert('Details updated successfully');
        setEditingData(null);
        // handleSearch();
      }
    } catch (error) {
      console.error('Error updating data:', error);
      alert("Failed to update. Please try again.");
    } finally {
      setLoading(false); // Reset loading state
    }
  };


  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Offset timezone difference
    return d.toISOString().slice(0, 10); // Get 'YYYY-MM-DD' format
  };


  const formatDateToDDMMYYYY = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Adjust for timezone difference
  
    const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with 0 if necessary
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with 0 if necessary
    const year = d.getFullYear(); // Get full year
  
    return `${day}/${month}/${year}`;
  };
  

  return (
    <>

    
      {/* <EmployeeDetails /> */}
      <input
        type="text"
        placeholder="Search by Employee Name or Email"
        className="search-bar"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setIsSearchBarActive(true)}
        onBlur={() => inputValue === '' && setIsSearchBarActive(true)}  // Reset the position if the search term is empty
        style={{display:'none'}}
      />


      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', cursor: 'pointer' }}>
        {/* <h2 style={{ color: 'red' }}>Other laptopacce</h2>  */}
        {/* Conditionally render + or - icon based on isFormOpen */}
        {isFormOpen ? (
          <i
            // className="fa-solid fa-minus"
            // style={{ fontSize: '26px', cursor: 'pointer', color: 'red' }}
            // onClick={handleToggleForm}
          ></i>
        ) : (
          <i
            // className="fa-solid fa-plus"
            // style={{ fontSize: '26px', cursor: 'pointer', color: 'red' }}
            // onClick={handleToggleForm}
          ></i>
        )}
      </div>

 
      <div>
      {isFormOpen && <LaptopAcceForm />}
      </div>

     <div style={{display:'flex' , width:'100%'}}> 
      <div className="search-results" >
  {laptopacce.length > 0 ? (
    <div className="device-list" style={{display:'flex'}}>
      {laptopacce.map((result, index) => (
        <div key={index} className="device-card" style={{
          border: '2px solid #ccc',
          borderRadius: '8px',
          padding: '15px',
          marginBottom: '15px',
          backgroundColor: '#f9f9f9',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          
        }}>
          <p><strong>DEVICE NAME:</strong> {result.deviceName || ''}</p>
          <p><strong>Date of Issue:</strong> {result.date_of_issue ? formatDateToDDMMYYYY(result.date_of_issue) : ''}</p>
          {/* <p><strong>Serial No.:</strong> {result.serial_no || ''}</p>
          <p><strong>Device Transferred:</strong> {result.device_transferred || ''}</p>
          <p><strong>Device Intake:</strong> {result.device_intake || ''}</p>
          <p><strong>Reporting Manager:</strong> {result.reporting_manager || ''}</p>
          <p><strong>Device Intake Date:</strong> {result.device_transferred_date ? formatDateToDDMMYYYY(result.device_transferred_date) : ''}</p> */}

          <div style={{ marginTop: '10px' }}>
            <button 
              onClick={() => handleEditClick(result)} 
              style={{ padding: '6px 12px', fontSize: '14px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px' }}
            >
              Edit
            </button>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
      {/* Optional placeholder for no results */}
      
    </div>
  )}
</div>
</div>





      {/* Editing form */}
      {editingData && (
        <div className="edit-form-popup">
  <div className="edit-form">
    <h3>Edit Employee Details</h3>
    <form onSubmit={handleFormSubmit} className="edit-form-container">

    <div className="form-field">
        <label>Device Name:</label>
        <input
          type="text"
          name="deviceName"
          value={editingData.deviceName}
          onChange={handleFormChange}
        />
      </div>


      <div className="form-field" style={{display:'none'}}>
        <label>Employee Name:</label>
        <input
          type="text"
          name="employee_name"
          value={editingData.employee_name}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field" style={{display:'none'}}>
        <label>Regional Office:</label>
        <input
          type="text"
          name="regional_office"
          value={editingData.regional_office}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field" style={{display:'none'}}>
        <label>Contact No.:</label>
        <input
          type="text"
          name="contact_no"
          value={editingData.contact_no}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field" style={{display:'none'}}>
        <label>Email:</label>
        <input
          type="text"
          name="personal_email_id"
          value={editingData.personal_email_id}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field" style={{display:'none'}}>
        <label>Address:</label>
        <input
          type="text"
          name="address"
          value={editingData.address}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field"  >
        <label>Date of Issue:</label>
        <input
          type="date"
          name="date_of_issue"
          value={editingData.date_of_issue ? formatDateToYYYYMMDD(editingData.date_of_issue) : ""}
          onChange={handleFormChange}
        />

      </div>
      <div className="form-field" style={{display:'none'}}>
        <label>Model Name:</label>
        <input
          type="text"
          name="model_name"
          value={editingData.model_name}
          onChange={handleFormChange}
        />
      </div>
      <div className="form-field" style={{display:'none'}}>
        <label>Serial No.:</label>
        <input
          type="text"
          name="serial_no"
          value={editingData.serial_no}
          onChange={handleFormChange}
        />
      </div>

      
      <div className="form-field" style={{display:'none'}}>
        <label>Device Transferred:</label>
        <select
          name="device_transferred"
          value={editingData.device_transferred || 'no'}
          onChange={handleFormChange}
        >
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
      </div>

      

      {/* Conditional Field: Show if Device Transferred is "Yes" */}
      {editingData.device_transferred === 'yes' && (
        <>
          <div className="form-field" >
            <label>Employee Name (Transferred):</label>
            <input
              type="text"
              name="device_transferred_employee_name"
              value={editingData.device_transferred_employee_name}
              onChange={handleFormChange}
            />
          </div>
          <div className="form-field">
            <label>Device Intake:</label>
            <select
              name="device_intake"
              className="custom-dropdown"
              value={editingData.device_intake || 'no'}
              onChange={handleFormChange}
            >
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>

          {editingData.device_intake === 'yes' && (
            <>
              <div className="form-field">
                <label>Reporting Manager:</label>
                <input
                  type="text"
                  name="reporting_manager"
                  value={editingData.reporting_manager}
                  onChange={handleFormChange}
                />
      </div>
              <div className="form-field">
                <label>Device Intake Date:</label>
                <input
                  type="date"
                  name="device_transferred_date"
                  value={editingData.device_transferred_date 
                          ? formatDateToYYYYMMDD(editingData.device_transferred_date)
                          : ''}
                  onChange={handleFormChange}
                />
              </div>
              <div className="form-field">
                <label>Exit Formality Complete:</label>
                <select
                  name="exit_formality_complete"
                  className="custom-dropdown"
                  value={editingData.exit_formality_complete || 'no'}
                  onChange={handleFormChange}
                >
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </select>
              </div>
            </>
          )}
        </>
      )}

      {formMode === 'edit' ? <button type="submit">Save Changes</button> : null}

      <button type="button" onClick={() => setEditingData(null)}>Cancel</button>
    </form>
  </div>
  </div>
)}


    </>
  )
}
